import router from '../router'

const state = {
  companySearch: '',
}

const getters = {}

const actions = {}

const mutations = {
  updateCompanySearch(state, payload) {
    state.companySearch = payload
  },
}

export const companies = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
